export default __webpack_public_path__ + "static/media/fastlane_detail9.3e5868b6.jpg";